import { render, staticRenderFns } from "./DeductionsPlanDetailsForm.vue?vue&type=template&id=647651e1&"
import script from "./DeductionsPlanDetailsForm.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports